const config = {
  environment: process.env.ENVIRONMENT,
  rollbar: {
    enabled: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN !== undefined,
    accessToken: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN
  }
};

export default config;